import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { CSVLink } from 'react-csv';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClientContext } from '../../context/client_context';
import { useAccountingContext } from '../../context/accounting_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'serty2', label: 'Filename', alignRight: false },
  { id: 'batchnu', label: 'Member', alignRight: false },
  { id: 'docode', label: 'EC #', alignRight: false },
  { id: 'startc', label: 'Gender', alignRight: false },
  { id: 'doccode3', label: 'Gender', alignRight: true },
  { id: 'startc4', label: 'Age', alignRight: false },
  { id: 'batchnu5', label: 'Designation', alignRight: true },
  { id: 'docode6', label: 'Retirement Date', alignRight: true },
  { id: 'doccode7', label: 'Province', alignRight: false },
  { id: 'endc', label: 'Amount', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function FileProvView() {
  const { clientRefId } = useClientContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [changeSubList, setChangeSubList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();
  const filename = `MemberSubs_${moment().format('[as on-]MMM-DD-YYYY[.xls]')}`;

  console.log('currentBatch in List', changeSubList);

  useEffect(() => {
    getFileRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getFileRecords = async () => {
    const cycleDate = 0;
    await axios(
      `${baseUrl}/api/ssb/GetRecordsProvByClientRefId?clientRefId=${clientRefId}&tenant=1`
    ).then(
      (result) => {
        console.log('returned v', result);
        setChangeSubList(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/report/getnew/ExtractSsbFiles/xls/0/1/${clientRefId}/0/0`)
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading Claims by Provider!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleClaimView = (e) => {
    console.log('e claimId', e.row.claim_ID);
    console.log('e claim#', e.row.claim_No);
    // setClaimNo(e.row.claim_ID);
    // getClaimDetailsById(e.row.claim_ID);
    // setShowDetails(true);
  };

  const openView = (e) => {
    navigate(`/claims/claim/${e}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - changeSubList.length) : 0;

  const filteredUsers = applySortFilter(changeSubList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Typography component="span" variant="h6" gutterBottom>
        SSB Membership Records
      </Typography>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={changeSubList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      employeeName,
                      ecNumber,
                      gender,
                      dateOfBirth,
                      age,
                      appDate,
                      ssb_designation,
                      grade,
                      stationDescription,
                      stat,
                      desc,
                      filename,
                      retirementDate,
                      province,
                      amount,
                      idNumber,
                      refId
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{filename}</TableCell>
                        <TableCell align="right">{employeeName}</TableCell>
                        <TableCell align="left">{ecNumber}</TableCell>
                        <TableCell align="right">{gender}</TableCell>
                        <TableCell align="right">{gender}</TableCell>
                        <TableCell align="left">{age}</TableCell>
                        <TableCell align="right">{ssb_designation}</TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(retirementDate).isValid()
                            ? moment(retirementDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{province}</TableCell>
                        <TableCell align="right">{amount}</TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleClaimView({ row })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={changeSubList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* <CSVLink data={changeSubList} filename={filename}> */}
      <Button
        type="button"
        variant="outlined"
        startIcon={<CloudDownloadIcon />}
        onClick={() => downloadDocument()}
      >
        Export to Excel
      </Button>
      {/* </CSVLink> */}
    </Container>
  );
}
